import { NavigationTabs } from '@/components/Common/NavigationTabs/NavigationTabs';
import { useIsMobile } from '@/utils/isMobile';
import { Box, Stack } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { Header } from './Header/Header';
import { useOrderDetailViewController } from './OrderDetailViewController';
import { OrderHistoryDialog } from './OrderHistory/OrderHistoryDialog/OrderHistoryDialog';
import { OrderResumeDialog } from './OrderResume/OrderResumeDialog/OrderResumeDialog';
import { OrderResumeSection } from './OrderResume/OrderResumeSection/OrderResumeSection';

export function OrderDetail() {
  const isMobile = useIsMobile();
  const { uiState } = useOrderDetailViewController();

  return (
    <Box sx={{ padding: { xs: '0px 0px 74px', md: '40px 49px 49px' } }}>
      <Header />
      {uiState.showNavigationTabs && (
        <NavigationTabs omitOutlet links={uiState.navTabs} />
      )}
      <Stack
        direction="row"
        spacing="16px"
        mt="16px"
        px={{ xs: '16px', md: '0px' }}
      >
        <Outlet />
        {!isMobile && <OrderResumeSection />}
      </Stack>
      <OrderResumeDialog />
      <OrderHistoryDialog />
    </Box>
  );
}
